import { render, staticRenderFns } from "./TopAsset.vue?vue&type=template&id=50ab9dc6&scoped=true"
import script from "./TopAsset.vue?vue&type=script&lang=js"
export * from "./TopAsset.vue?vue&type=script&lang=js"
import style0 from "./TopAsset.vue?vue&type=style&index=0&id=50ab9dc6&prod&lang=css"
import style1 from "./TopAsset.vue?vue&type=style&index=1&id=50ab9dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab9dc6",
  null
  
)

export default component.exports